import { apiFetch } from '../client';

export function bookDemo(data) {
    return apiFetch("/create-treeform-demo/", {
        method: 'POST',
        body: JSON.stringify({ "data": data }),
    })
}